import { enrichAnalyticsUser } from '@devsbb/analytics-client';

const CONSENT_KEY = 'ajs_cookie_consent';

export type MarketingCookieConsent = 'yes' | 'no' | 'none';

export const trackCookieConsentAnalytics = (consent: MarketingCookieConsent): void => {
    const previousConsent = sessionStorage.getItem(CONSENT_KEY);
    if (previousConsent === consent) return;

    sessionStorage.setItem(CONSENT_KEY, consent);
    enrichAnalyticsUser({ marketing_consent: consent });
};
